module.exports = __webpack_public_path__ + "img/touhou.7d66c9bd.png";